import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'

// Define DialogProps interface
interface DialogProps {
  open: boolean
  setOpen: (newState: boolean) => void
  confirmFx: () => void
  title: string
  description: string
}

/**
 * `Copyright` component declaration.
 * @param {Boolean} open
 * @param {Function} setOpen
 * @param {Function} confirmFx
 * @param {String} title
 * @param {String} description
 * @return DialogConfirm
*/
const DialogConfirm = ({ open, setOpen, confirmFx, title, description }: DialogProps): JSX.Element => {

  /**
   * This method is used to close dialog
   * @Return {void}
   */
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {description}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={confirmFx} color="primary">
            Si
          </Button>
          <Button onClick={handleClose} color="primary" autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default DialogConfirm